import type { GeoLocation } from '../../types/core';

/** Persists municipality wizard data between the profile step and plan/checkout (sessionStorage). */
export const MUNICIPALITY_ONBOARDING_DRAFT_KEY =
  'bn_municipality_onboarding_draft_v1';

/**
 * Snapshot after personal data + job functions + avatar, before authority creation.
 */
export interface MunicipalityOnboardingDraft {
  personalForm: Record<string, any>;
  personalLocation?: GeoLocation;
  selectedJobFunctions: {
    value: string;
    jobLevels: string[];
    jobLevelDescriptions: string[];
    /** null = not answered yet. */
    inStudy: boolean | null;
    /** null = not answered; missing in drafts saved before the question. */
    isQualified?: boolean | null;
  }[];
  avatarBase64?: string;
  /** Schulgemeinde step + «Zusammenfassung» (same data as summary). */
  authorityForm?: Record<string, any>;
  schoolLocation?: GeoLocation;
  currentStepIndex: number;
}

export function saveMunicipalityOnboardingDraft(
  draft: MunicipalityOnboardingDraft
): void {
  sessionStorage.setItem(
    MUNICIPALITY_ONBOARDING_DRAFT_KEY,
    JSON.stringify(draft)
  );
}

export function loadMunicipalityOnboardingDraft(): MunicipalityOnboardingDraft | null {
  try {
    const raw = sessionStorage.getItem(MUNICIPALITY_ONBOARDING_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as MunicipalityOnboardingDraft;
  } catch {
    return null;
  }
}

export function clearMunicipalityOnboardingDraft(): void {
  sessionStorage.removeItem(MUNICIPALITY_ONBOARDING_DRAFT_KEY);
}
